import { Component, type ErrorInfo, type ReactNode } from 'react';

type Props = { children: ReactNode };
type State = { error: Error | null };

// Catches render-time crashes (e.g. a run record referencing data the app no longer
// recognises) so the instructor sees a German message instead of a blank page mid-exam.
export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('OrgSim ist abgestürzt:', error, info.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="flex h-full flex-col items-center justify-center gap-2 p-8 text-center text-sm text-neutral-300">
          <p className="text-base font-medium text-red-300">Unerwarteter Fehler.</p>
          <p>Bitte die Seite neu laden. Bereits gesicherte Daten gehen dabei nicht verloren.</p>
        </div>
      );
    }
    return this.props.children;
  }
}
